import React from 'react';
import PropTypes from 'prop-types';
import MessagePopup from "./MessagePopup";
import JoinClassNames from "../../common/JoinClassNames";
import AriaLiveContext from '../aria-live/AriaLiveContext';
import MessagePopupTypes from './MessagePopupTypes';


const propTypes = {
	className: PropTypes.string,

	// (message, pressedButtonText) => { ... whatever you want ... }
	onClosePopup: PropTypes.func,
};

const defaultProps = {
	className: undefined,
	onClosePopup: undefined,
};

export class MessagePopupCore extends React.Component {
	static contextType = AriaLiveContext;

	constructor(props) {
		super(props);

		this.messages = [];
		this.counter = 0;
	}

	componentDidMount() {
		registerMessagePopup(this);
	}

	componentWillUnmount() {
		unregisterMessagePopup(this);
	}

	addMessage = (content) => {
		this.counter++;
		content.keyName = `MessagePopup${this.counter}`;
		this.messages = this.messages.concat(content);
		this.forceUpdate();
	};

	onClosePopup = pressedButtonText => {
		const message = this.messages[0];
		this.messages = this.messages.slice(1);
		this.forceUpdate();
		message.closeCallback && message.closeCallback(message, pressedButtonText);
		this.props.onClosePopup && this.props.onClosePopup(message, pressedButtonText);
		
		//indicate the dialog was closed
		let delay = setTimeout(() => {
			const { addAriaLiveAssertiveMessage, addAriaLivePoliteMessage } = this.context;
			addAriaLivePoliteMessage('Popup message closed');
			clearTimeout(delay);
		}, 200);
	};

	render() {
		let retVal = null;
		if (this.messages.length) {
			const {
				className,
				...restOfMessage
			} = this.messages[0];

			retVal = <MessagePopup
				onClosePopup={this.onClosePopup}
				className={JoinClassNames(this.props.className, className)}
				role={this.messages[0].type === MessagePopupTypes.DIALOG ? 'alertdialog' : 'alert'}
				{...restOfMessage}
			/>;
		}
		return retVal;
	}
}

MessagePopupCore.propTypes = propTypes;
MessagePopupCore.defaultProps = defaultProps;

const popups = [];

function registerMessagePopup(messagePopup) {
	popups.push(messagePopup);
}

function unregisterMessagePopup(messagePopup) {
	popups.splice(popups.indexOf(messagePopup), 1);
}

/**
 * Add a message to the message queue and render it.
 *
 * @param {object} obj The message object
 * @param {string} obj.title The message title
 * @param {string} obj.message The message body
 * @param {string} obj.subMessage The sub-message
 * @param {function} obj.icon The icon functional component
 * @param {string} obj.className A CSS class for the popupWindow
 * @param {string} obj.type The type of message popup (see MessagePopupTypes)
 * @param {string} obj.position The position of the banner or snackbar (see MessagePopupPositions)
 * @param {string} obj.duration The duration of the snackbar
 * @param {string} obj.buttonText The text of the MessagePopup button
 * @param {function} obj.closeCallback A function to call when the user closes the message: (message, pressedButtonText) => { ... }
 * @param {bool} obj.hasCancelButton Show the cancel button
 * @param {string} obj.cancelButtonText The text of the MessagePopup cancel button
 * @param {element} obj.returnFocusElement
 */
MessagePopupCore.addMessage = ({ title, message, subMessage, icon, className, type, position, duration, buttonText, closeCallback, hasCancelButton, cancelButtonText, returnFocusElement }) => {
	popups.forEach(popup => popup.addMessage({ title, message, subMessage, icon, className, type, position, duration, buttonText, closeCallback, hasCancelButton, cancelButtonText, returnFocusElement }));
};
